'use client'
import { Icon } from '@/components'
import { handleCopyContent } from '@/utils/copy-content'
import { SvgIconProps, Tooltip } from '@mui/material'
import { useTranslations } from 'next-intl'

export const CopyBtn = ({
  code,
  props,
}: {
  code: string
  props?: Omit<SvgIconProps, 'onClick' | 'children'>
}) => {
  const t = useTranslations()
  return (
    <Tooltip title={t('Sao chép')}>
      <Icon.CopyV2
        {...props}
        sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' }, cursor: 'pointer', ...props?.sx }}
        onClick={() => {
          handleCopyContent(code)
        }}
      />
    </Tooltip>
  )
}
